import * as React from 'react'

import { FieldDataValue } from 'embed/constants'
import { Fields } from 'embed/constants/fields'

import { StepTitle } from 'embed/components/Application/StepTitle'
import { ApplicationField } from 'embed/components/ApplicationField/container'
import { Product } from 'even-ts-static'
import Wrapper from '../Wrapper'

export interface Props {
  directReferral: boolean
  dispatchBackToStepOne: () => void
  hideLoanPurpose: boolean
  loanPurposeOnChange?: (value: FieldDataValue) => void
  onBack: () => void
  onContinue: () => void
  stepByStepApplicationStepIsValid: boolean
  currentStep: number
  totalNumberOfSteps: number
}

const StepbystepApplicationStepLoanPurpose: React.FC<Props> = (props) => (
  <Wrapper backToSearch={props.currentStep === 0} {...props}>
    <StepTitle>Why do you need a loan?</StepTitle>
    <ApplicationField
      field={Fields.LoanPurpose}
      hidden={props.hideLoanPurpose}
      onChange={props.loanPurposeOnChange}
      product={Product.Loan}
    />
  </Wrapper>
)

export default StepbystepApplicationStepLoanPurpose
